const Backbone = require('backbone');
const CartItemModel = require('app/models/store/client/cart/item');
var FinishSamplesView = Backbone.View.extend({
	el: '.finish-samples',

	events: {
		'click .add-finish-sample': '_addFinishSample'
	},

	initialize: function() {
		this.listenTo(Backbone, 'finish:hover', this._changeFinishSample.bind(this));
		this.listenTo(Backbone, 'finish:clicked', this._changeFinishSample.bind(this));

		this.finishSampleUniqueId = null;
		this.$button = this.$el.find('.add-finish-sample');
	},

	_changeFinishSample: function(data) {
		if (data.finishSampleUniqueId) {
			this.finishSampleUniqueId = data.finishSampleUniqueId;
			this.$el.removeClass('hidden');
		} else {
			this.finishSampleUniqueId = null;
			this.$el.addClass('hidden');
		}
	},

	_addFinishSample: function() {
		var cartItemModel = new CartItemModel({
			quantity: 1,
			uniqueId: this.finishSampleUniqueId
		});

		this.$button.button('loading');

		cartItemModel.save(null, {
			success: this._addFinishSampleCallback.bind(this),
			error: this._addFinishSampleCallback.bind(this)
		});
	},

	_addFinishSampleCallback: function(model, response) {
		if (response.status === 1) {
			Backbone.trigger('addToCart:productAdded', model);
			Backbone.trigger('cart:quantityChanged', model.get('cart').quantity);
			Backbone.trigger('omniture:productaddtocart', 'finish-sample', response, model, null);
			window.BCOM.notifications.render('You have added a finish sample to your cart.', 'success');
		} else {
			window.BCOM.notifications.render('There was a problem adding this finish sample to your cart. Please try again.', 'danger');
		}
		this.$button.button('reset');
	}
});

module.exports = FinishSamplesView;
